const PLAYER_MARKET_CATEGORY = 'player';
const PLAYER_MOST_KILLS_MATCHUP_CATEGORY = 'player_matchups';
const PLAYER_HEADSHOTS_CATEGORY = 'players_headshots';
const PLAYER_ASSISTS_CATEGORY = 'players_assists';
const PLAYER_FIXED_LINES_CATEGORY = 'player_fixed_line';
const PREBUILT_CATEGORY = 'prebuilt';
const PREBUILT_STORYBUILDER_TEMPLATE = 'prebuilt-storybuilder';
const TIME_WINDOW_MARKET_CATEGORY_PART = 'time_window';
const PLAYER_HEADSHOTS_TEMPLATE_PART = 'headshot';
const PLAYER_ASSISTS_TEMPLATE_PART = 'assist';
const PLAYER_MARKET_KILLS_CATEGORY_PART = 'players';

export {
  PLAYER_MARKET_CATEGORY,
  PLAYER_MOST_KILLS_MATCHUP_CATEGORY,
  PLAYER_HEADSHOTS_CATEGORY,
  PLAYER_ASSISTS_CATEGORY,
  PLAYER_FIXED_LINES_CATEGORY,
  PREBUILT_CATEGORY,
  PREBUILT_STORYBUILDER_TEMPLATE,
  TIME_WINDOW_MARKET_CATEGORY_PART,
  PLAYER_HEADSHOTS_TEMPLATE_PART,
  PLAYER_ASSISTS_TEMPLATE_PART,
  PLAYER_MARKET_KILLS_CATEGORY_PART
};
